import auth from '@client/components/auth';

export type Role = 'admin' | 'moderator' | 'contentEditor' | 'unknown';

export const getRole = (): Role => {
  if (auth.isAdministrator()) return 'admin';
  if (auth.isModerator()) return 'moderator';
  if (auth.isContentEditor()) return 'contentEditor';
  return 'unknown';
};
